import { render, staticRenderFns } from "./logins.vue?vue&type=template&id=4f981f8c&scoped=true"
import script from "./logins.vue?vue&type=script&lang=js"
export * from "./logins.vue?vue&type=script&lang=js"
import style0 from "./logins.vue?vue&type=style&index=0&id=4f981f8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f981f8c",
  null
  
)

export default component.exports